import { gql } from '@apollo/client';

/**
 * GraphQL query to fetch audit session statistics
 * Part of the 4-query architecture for optimized data fetching
 * Uses the existing auditSessionStats root query resolver
 */
export const GET_AUDIT_SESSION_STATS = gql`
  query GetAuditSessionStats($auditSessionId: ID!) {
    auditSessionStats(auditSessionId: $auditSessionId) {
      totalCount
      completeCount
      skippedCount
      incompleteCount
      canComplete
    }
  }
`;
